





































































































































































































































import { Component, Emit, Model, Prop, Ref, Watch, Vue } from "vue-property-decorator";
import { getModule } from 'vuex-module-decorators';
import Modelling from "@/store/modules/Modelling";
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { Factor, FactorGroup, FactorResource } from '@/api/model/FactorResource';
import FactorNavigation from "@/components/navigation/FactorNavigation.vue";
import ScoringKeyCreator from "@/components/scoring-key/ScoringKeyCreator.vue";
import LinearScoringDefinitionRuleCreator from "@/components/scoring-definition/numeric/LinearScoringDefinitionRuleCreator.vue";
import CategoricalScoringDefinitionRuleCreator from "@/components/scoring-definition/categorical/CategoricalScoringDefinitionRuleCreator.vue";
import BooleanScoringDefinitionRuleCreator from "@/components/scoring-definition/boolean/BooleanScoringDefinitionRuleCreator.vue";
import { ValueTypeDefinition } from "@/api/model/FactorResource";
import Histogram from "@/components/common/Histogram.vue";
import DateTimeScoringDefinitionRuleCreator from "@/components/scoring-definition/date-time/DateTimeScoringDefinitionRuleCreator.vue";

const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions);

const SCORING_FUNCTIONS = {
    MANUAL: {
        name: "Manual",
        description: "Manually define a scoring key and take control of scoring each choice manually.",
        value: "MANUAL"
    },
    CATEGORICAL_BINNING: {
        name: "Binning",
        description: "Specify what values correspond to specific scores by placing them into bins.",
        value: "CATEGORICAL"
    },
    LINEAR: {
        name: "Linear",
        description: "Linearly score values between two specific numerical values.",
        value: "LINEAR"
    },
    STEP: {
        name: "Step",
        description: "Score values by defining a step function for values.",
        value: "STEP"
    },
    BOOLEAN: {
        name: "Boolean",
        description: "Set a pass or fail by whether the value is true or false or some variant of that structure.",
        value: "BOOLEAN"
    },
    DATE_TIME: {
        name: "Date and Time",
        description: "Specify values corresponding to dates.",
        value: "DATE_TIME"
    }
};

const VALUE_TYPE_FUNCTIONS = {
    NUMERICAL: [SCORING_FUNCTIONS.LINEAR],
    CATEGORICAL: [SCORING_FUNCTIONS.CATEGORICAL_BINNING],
    BOOLEAN: [SCORING_FUNCTIONS.BOOLEAN],
    DATE_TIME:[SCORING_FUNCTIONS.DATE_TIME],
    TEXT: [],
    FILE: [],
    NONE: []
};

@Component({
    components: {
        BooleanScoringDefinitionRuleCreator,
        CategoricalScoringDefinitionRuleCreator,
        LinearScoringDefinitionRuleCreator,
        ScoringKeysCreator: ScoringKeyCreator,
        FactorNavigationTree: FactorNavigation,
        Histogram,
        DateTimeScoringDefinitionRuleCreator,
        FactorNavigation: () => import("@/components/navigation/FactorNavigation.vue"),
    },
})

export default class FactorScoringDefinitionCreator extends Vue {
    private VALUE_TYPE_FUNCTIONS: any = VALUE_TYPE_FUNCTIONS;
    private SCORING_FUNCTIONS = SCORING_FUNCTIONS;
   
    @Model("updated:scoringDefinition")
    scoringDefinition!: any;

    @Prop()
    defaultScoringKeys!: any[];

    @Prop()
    name!: string;

    @Prop()
    factorId!: string;

    @Prop()
    decisionId!: string;

    @Prop()
    inheritedFromName!: string;

    @Prop({})
    valueTypeDefinition!: ValueTypeDefinition;

    @Prop({})
    choiceValues!: any[]

    @Prop({default: false})
    loading!: boolean;

    @Prop({default: false})
    deleteEnabled!: boolean

    @Prop({default: false})
    showFactorTab!: boolean

    step = 0;
    private selectedScoringFunction: string = 'MANUAL';
    private scoringKeys: any[] = [];
    private defaultScore: number = 0;
    private defaultMissingValueScore: number = 0;
    private resultingScoringRules: any[] = [];
    private isScoringAutomatic = false;
    private rules = {
        required: (value: number) => 0 <= value && value <= 100  || 'Value must be between 0 and 100',
        rulesEmpty: (value: boolean) => (!value ? (this.resultingScoringRules.length === 0 ?  'Add Scoring Rules in the Rules tab':  this.resultingScoringRules.indexOf((sk: any)=> sk.scoringFunction === 'MANUAL') < 0) : true)
        
    };

    private tabs = ["Keys", "Rules", "Factors"];
    private tab = 0;
    private isFormValid = true
    private inc = 0;
    @Ref()
    private form: HTMLFormElement;

    private selectedFactorIds: string[] = [];

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getSubTree(this.startingFactors);
        }
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get startingFactors() {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M'
            return this.getTopGroup('M')
        
        } else {
            return 'M'
        }   
    }

    get isFactorListActive() {
        if (workspaceOptionsModule.activeFactorLists) {
            return workspaceOptionsModule.activeFactorLists.length > 0
        }
        return false;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get type() {
        if (this.selectedScoringFunction == null) return this.selectedScoringFunction;
        if (['LINEAR', 'STEP'].includes(this.selectedScoringFunction)) {
            return "NUMERIC"
        }
        return this.selectedScoringFunction
    }

    get valueType() {
        if (this.valueTypeDefinition) {
            return this.valueTypeDefinition.valueType
        }
    }

    get prefix() {
        if (this.valueTypeDefinition) {
            return this.valueTypeDefinition.valuePrefix
        }
    }

    get suffix() {
        if (this.valueTypeDefinition) {
            return this.valueTypeDefinition.valueSuffix
        }
    }

    get categoricalValues() {
        if (this.valueTypeDefinition) {
            return this.valueTypeDefinition.categoricalValues
        }
    }

    get isValid() {
        
        return true;
    
    }

    get dateFormat() {
        if (this.valueTypeDefinition) {
        
            return (this.valueTypeDefinition.format) ? (this.valueTypeDefinition.format): 'YYYY-MM-DD';
        }
    }

    get doesValueTypeHaveScoring() {
        return this.VALUE_TYPE_FUNCTIONS[this.valueType][0] != null
    }

    get scoringRules() {
        return this.resultingScoringRules || []
    }

    get numKeys() {
        return this.scoringKeys.length;
    }

    private getSubTree(factorResourceId: string): { id: string, name?: string, children: any[] } {
        let factorGroup = this.factorResources[factorResourceId] as FactorGroup;
        let childrenIds: string[];
        if (
            factorGroup.groupTypeDefinition
            && (
                factorGroup.groupTypeDefinition.type === 'TABLE_FIXED'
            )
        ) {
            
        } else {
            
            childrenIds = this.factorResources[this.getTopGroup(factorGroup.id)].childrenIds || [];
        }
        if (!childrenIds) { childrenIds = []; }
        let children = childrenIds
            .filter(id => this.isFactorVisible(id))
            .filter(f => this.factorResources[f])
            .map((cId: string) => {
                let resource = this.factorResources[cId];
                if (resource.type === 'FACTOR') {
                    return {
                        id: cId,
                        name: resource.name,
                        locked: cId == this.factorId
                    }
                }
                return this.getSubTree(cId)
            })

        return {
            id: factorResourceId,
            name: factorGroup.name,
            children: children
        }
    }

    private getTopGroup(topId: string) {
        if(!workspaceOptionsModule.trimTopGroups) {
            return topId;
        }

        if(this.factorResources[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return topId
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0])
        }
    }

    private isFactorVisible(resourceId: string) {
        //If no list active or showallFactors button toggled on
        if(this.showNonListFactors || !this.isFactorListActive) {
            //return this.contributingVisibility || (!this.contributingVisibility && this.contributingFactors[resourceId])
            return true;
        }
        //If list active and showAllFactors is off, then filter 
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        } 
       
    }

    mounted() {
        if (this.scoringDefinition && this.scoringDefinition.scoringRules) {
            if (this.scoringDefinition.type === 'NUMERIC') {
                // They should all be the same for now
                this.selectedScoringFunction = this.scoringDefinition.scoringRules[0].scoringFunction
            } else {
                this.selectedScoringFunction = this.scoringDefinition.type;
            }
            this.resultingScoringRules = JSON.parse(JSON.stringify(this.scoringDefinition.scoringRules));
            this.scoringKeys = this.scoringDefinition.scoringRules.map((sr: any) => sr.scoringKey)
            this.defaultMissingValueScore = this.scoringDefinition.missingDataDefaultScore;
            this.defaultScore = this.scoringDefinition.defaultScore;

            if (this.selectedScoringFunction === 'MANUAL') {
                this.isScoringAutomatic = false;
            } else {
                this.isScoringAutomatic = true;
                this.form.validate()

            }
        } else {
            if (this.defaultScoringKeys && this.defaultScoringKeys.length > 0) {
                this.scoringKeys = JSON.parse(JSON.stringify(this.defaultScoringKeys));
            }
        }
    }

    @Emit("updated:scoringDefinition")
    @Emit()
    private submit() {
        let type = this.type;
        if (this.resultingScoringRules && this.resultingScoringRules.map((scr: any) => scr.scoringFunction).filter((sf: string) => sf === 'MANUAL').length > 0) {
            type = 'MANUAL';
        }
        return {
            defaultScore: this.defaultScore,
            missingDataDefaultScore: this.defaultMissingValueScore,
            type: type,
            scoringRules: this.resultingScoringRules,
            factors: [...this.selectedFactorIds, this.factorId]
        }
    }

    private onChangeAutomaticScoring() {
        if(this.isScoringAutomatic) {
            if (this.valueType) {
                this.selectedScoringFunction = this.VALUE_TYPE_FUNCTIONS[this.valueType][0].value
                this.resultingScoringRules = [];
            }
        }

        if(this.tab ===1){
            this.tab = 0;
        }

        else {
            this.tabs = ["Keys"]
        }
    }

    private preScreenSubmit() {
         if (!this.form.validate()) {
            return;
        }

        if(!this.isScoringAutomatic) {
            this.selectedScoringFunction = 'MANUAL'
            
            this.resultingScoringRules = this.scoringKeys.map(sk => {
                return {scoringFunction: 'MANUAL', scoringKey: sk}
            })
            this.submit();
        }
        else{
            this.selectedScoringFunction = this.VALUE_TYPE_FUNCTIONS[this.valueType][0].value;
            this.resultingScoringRules.map((rule: any, index) => Vue.set(rule, 'scoringKey', this.scoringKeys[index]));
            this.submit()
        }
        
    }

    private selectFactor(payload) {
        this.selectedFactorIds = payload;
    }

    @Watch('resultingScoringRules', {deep: true})
    onChangeScoringResults(){
        this.inc = this.inc + 1;
    }

    private clearScoringRules() {
        this.resultingScoringRules = [];
    }




}
